import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WideLayout } from '../layouts/BaseLayout';
import '../styles/page-components.css';
import './Prices.css';

const Prices = ({ user }) => {
    const { t } = useTranslation();
    const [billingCycle, setBillingCycle] = useState('monthly');
    const [showModal, setShowModal] = useState(false);

    const currentPlan = user?.status || (user ? 'Free' : '');

    return (
        <WideLayout>
            <header className="page-header">
                <h1 className="page-title">{t('pages.prices.title')}</h1>
            </header>

            <div className="card-grid card-grid-3">
                {/* Free Plan */}
                <div className="content-card price-card">
                    {user && currentPlan === 'Free' && (
                        <div className="price-card-current-badge early-bird-badge">
                            {t('pages.prices.free.current')}
                        </div>
                    )}
                    <div className="price-card-header price-card-header-centered">
                        <h2 className="price-card-title">{t('pages.prices.free.title')}</h2>
                    </div>
                    <div className="price-card-amount price-card-amount-early-bird">
                        {t('pages.prices.free.price')}
                    </div>
                    <ul className="price-feature-list">
                        {t('pages.prices.free.features', { returnObjects: true }).map((feature, i) => (
                            <li key={i} className="price-feature-item">
                                <span className="price-feature-check price-feature-check-green">✓</span>
                                <span>{feature}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* PRO Plan */}
                <div className="content-card price-card price-card-highlighted">
                    {user && (currentPlan === 'PRO' || currentPlan === 'EarlyBird') && (
                        <div className="price-card-current-badge early-bird-badge">
                            {t('pages.prices.pro.current')}
                        </div>
                    )}

                    <div className={`price-card-header ${currentPlan === 'EarlyBird' ? 'price-card-header-centered' : ''}`}>
                        <h2 className={`price-card-title ${currentPlan !== 'EarlyBird' ? 'price-card-title-gradient' : ''}`}>
                            {currentPlan === 'EarlyBird' ? 'Early Bird' : t('pages.prices.pro.title')}
                        </h2>
                        {currentPlan !== 'EarlyBird' && (
                            <div className="billing-toggle">
                                <button
                                    onClick={() => setBillingCycle('monthly')}
                                    className={`billing-toggle-btn ${billingCycle === 'monthly' ? 'active' : ''}`}
                                >
                                    Month
                                </button>
                                <button
                                    onClick={() => setBillingCycle('yearly')}
                                    className={`billing-toggle-btn ${billingCycle === 'yearly' ? 'active' : ''}`}
                                >
                                    Year
                                </button>
                            </div>
                        )}
                    </div>

                    <div className={`price-card-amount ${currentPlan === 'EarlyBird' ? 'price-card-amount-early-bird' : 'price-card-amount-pro'}`}>
                        {currentPlan === 'EarlyBird'
                            ? t('pages.prices.early_bird.price', 'Free for you')
                            : (billingCycle === 'monthly' ? t('pages.prices.pro.price_monthly') : t('pages.prices.pro.price_yearly'))
                        }
                    </div>

                    <ul className="price-feature-list price-feature-list-with-margin">
                        {t('pages.prices.pro.features', { returnObjects: true }).map((feature, i) => (
                            <li key={i} className="price-feature-item">
                                <span className="price-feature-check price-feature-check-purple">✓</span>
                                <span>{feature}</span>
                            </li>
                        ))}
                    </ul>

                    {currentPlan !== 'PRO' && currentPlan !== 'EarlyBird' && (
                        <button className="submit-btn price-upgrade-btn" disabled>
                            Coming soon...
                        </button>
                    )}
                </div>

                {/* Closed Communities */}
                <div className="content-card price-card price-card-communities">
                    <div className="price-card-header price-card-header-centered">
                        <h2 className="price-card-title price-card-title-communities">
                            {t('pages.prices.communities.title')}
                        </h2>
                    </div>
                    <div className="price-card-amount price-card-amount-communities">
                        {t('pages.prices.communities.price')}
                    </div>
                    <ul className="price-feature-list price-feature-list-with-margin">
                        {t('pages.prices.communities.features', { returnObjects: true }).map((feature, i) => (
                            <li key={i} className="price-feature-item">
                                <span className="price-feature-check price-feature-check-teal">✓</span>
                                <span>{feature}</span>
                            </li>
                        ))}
                    </ul>
                    <button
                        className="submit-btn price-communities-btn"
                        onClick={() => setShowModal(true)}
                    >
                        {t('pages.prices.communities.button')}
                    </button>
                </div>
            </div>

            {showModal && (
                <div className="communities-modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="communities-modal" onClick={(e) => e.stopPropagation()}>
                        <button className="communities-modal-close" onClick={() => setShowModal(false)}>
                            &times;
                        </button>
                        <h2 className="communities-modal-title">
                            {t('pages.prices.communities.modal_title')}
                        </h2>
                        <p className="communities-modal-text">
                            {t('pages.prices.communities.modal_text_1')}
                        </p>
                        <p className="communities-modal-text">
                            {t('pages.prices.communities.modal_text_2')}
                        </p>
                        <p className="communities-modal-cta">
                            {t('pages.prices.communities.modal_cta')}{' '}
                            <a
                                href="https://t.me/max_postnikov"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="communities-modal-link"
                            >
                                @max_postnikov
                            </a>
                        </p>
                        <button
                            className="submit-btn communities-modal-close-btn"
                            onClick={() => setShowModal(false)}
                        >
                            {t('pages.prices.communities.modal_close')}
                        </button>
                    </div>
                </div>
            )}
        </WideLayout>
    );
};

export default Prices;
